import { render, staticRenderFns } from "./listCategories.vue?vue&type=template&id=2695201a&scoped=true"
import script from "./listCategories.vue?vue&type=script&lang=js"
export * from "./listCategories.vue?vue&type=script&lang=js"
import style0 from "./listCategories.vue?vue&type=style&index=0&id=2695201a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695201a",
  null
  
)

export default component.exports